export const createRequestBody = (values, domainCode, id, userToEdit) => {
    //differentiate between edit and create
    let requestObject = {};
    if (domainCode) {
       
        requestObject = {
            domainCode: domainCode,
            issuerCode: values.issuerCode ? values.issuerCode  : "",
            issuerName: values.issuerName ? values.issuerName : "",
            bankCode: values.bankCode,
            issuerNr: values.issuerNr,
            reportPrefix: values.reportPrefix ? values.reportPrefix : "",
        };
    } else {
        requestObject = {
            domainCode: values.domains ? values.domains.code : "",
            issuerCode: values.scpIssuers ? values.scpIssuers.issuerCode.trim(" ") : "",
            issuerName: values.scpIssuers ? values.scpIssuers.issuerName : "",
            bankCode: values.bankCode,
            issuerNr: values.issuerNr,
            reportPrefix: values.reportPrefix ? values.reportPrefix : "",
        };
    }
  
    return requestObject;
};
